/* HorecaBayim — yüzen iletişim balonu birincil butonları kapatmasın.

   Mobil ürün sayfasında balon (sağ alt, sabit) "Bayi Başvurusu Yap" ve
   "Sepete ekle" gibi birincil butonların sağ ucunun üstüne biniyordu
   (2026-10-05 renk incelemesi, 390px). Kaydırma/yeniden boyutlandırmada
   balonun KENDİ (kaydırılmamış) konumu görünür birincil butonlarla
   karşılaştırılır; çakışma varsa balon, butonun üst kenarının 12px
   yukarısına çıkacak kadar yukarı kaydırılır, çakışma kalkınca geri iner.
   Buton ekranın üst yarısındaysa kaydırmak balonu ekranın ortasına taşırdı;
   o durumda balon geçici olarak saydamlaşır ve tıklanamaz olur.
   Yalnız görsel yerleşim; hiçbir bileşenin davranışı değişmez. */
(function () {
  'use strict';

  var bubble = document.querySelector('[data-hb-bubble]');
  if (!bubble) return;

  var PRIMARY = [
    '.hb-btn--solid', '.hb-btn--ghost', '.hb-price__cta', '[data-hb-rfq-link]',
    'button[name="checkout"]', '.cart__checkout-button', '#dealer-registration-submit',
    '.dqo-add-to-cart', '.dsl-add-to-cart'
  ].join(',');

  function visible(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  var pending = false;
  function check() {
    pending = false;
    // kaydırılmamış konum: transform geçici olarak kaldırılmadan, mevcut
    // kaydırma miktarı geri eklenerek hesaplanır (yerleşim titremesin)
    var shift = parseFloat(bubble.style.getPropertyValue('--hb-bubble-dodge')) || 0;
    var dodging = bubble.classList.contains('hb-bubble--dodge');
    var b = bubble.getBoundingClientRect();
    var base = { left: b.left, right: b.right, top: b.top - (dodging ? shift : 0),
                 bottom: b.bottom - (dodging ? shift : 0) };
    var rects = [];
    var list = document.querySelectorAll(PRIMARY);
    for (var i = 0; i < list.length; i++) {
      if (!bubble.contains(list[i]) && visible(list[i])) rects.push(list[i].getBoundingClientRect());
    }
    // Üst üste duran butonlar (ör. "Bayi girişi" + "Bayi Başvurusu Yap"):
    // balon alttakinden kaçarken üsttekine binmesin diye yeni konum tekrar
    // denetlenir. Balon ekranın üst yarısına kadar çıkmak zorunda kalırsa
    // kaydırmak yerine geçici olarak gizlenir.
    var need = 0, hide = false;
    for (var pass = 0; pass < 6; pass++) {
      var top = base.top - need, bottom = base.bottom - need, hit = null;
      for (var j = 0; j < rects.length; j++) {
        var r = rects[j];
        if (r.left < base.right + 8 && r.right > base.left - 8 &&
            r.top < bottom + 8 && r.bottom > top - 8) { hit = r; break; }
      }
      if (!hit) break;
      need = base.bottom - hit.top + 12;
      if (base.top - need < window.innerHeight * 0.5) { hide = true; need = 0; break; }
    }
    if (need > 0) {
      bubble.style.setProperty('--hb-bubble-dodge', (-need) + 'px');
      bubble.classList.add('hb-bubble--dodge');
    } else {
      bubble.classList.remove('hb-bubble--dodge');
      bubble.style.removeProperty('--hb-bubble-dodge');
    }
    bubble.style.opacity = hide ? '0' : '';
    bubble.style.pointerEvents = hide ? 'none' : '';
  }

  // Kaydırmadan hemen sonra yapışkan header küçülürken yerleşim birkaç yüz
  // ms daha değişiyor; ilk ölçüm eski konumla yapılabiliyor. Hareket
  // durduktan sonra bir kez daha ölçülür.
  var trail = 0;
  function schedule() {
    clearTimeout(trail);
    trail = setTimeout(check, 350);
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || setTimeout)(check);
  }

  // Horizon'da kaydırma .page-wrapper içinde olabiliyor: capture ile her
  // kaydırılabilir öğeden gelen olay yakalanır.
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
})();
